var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGrip(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 10,
    viewBox: "0 0 22 10",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_8871",
    "data-name": "Group 8871",
    transform: "translate(-343 -451)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1492",
    "data-name": "Rectangle 1492",
    width: 2,
    height: 10,
    rx: 1,
    transform: "translate(353 451)",
    fill: "#0f3557",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1493",
    "data-name": "Rectangle 1493",
    width: 2,
    height: 10,
    rx: 1,
    transform: "translate(363 451)",
    fill: "#0f3557",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1494",
    "data-name": "Rectangle 1494",
    width: 2,
    height: 10,
    rx: 1,
    transform: "translate(358 451)",
    fill: "#0f3557",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1495",
    "data-name": "Rectangle 1495",
    width: 2,
    height: 10,
    rx: 1,
    transform: "translate(343 451)",
    fill: "#0f3557",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1496",
    "data-name": "Rectangle 1496",
    width: 2,
    height: 10,
    rx: 1,
    transform: "translate(348 451)",
    fill: "#0f3557",
    opacity: 0.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrip);
export default __webpack_public_path__ + "static/media/grip.9011f12399207570bab9a6732edf430a.svg";
export { ForwardRef as ReactComponent };